<template>
  <div class="document-wrapper">
    <div class="columns centered">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteRequiredInformationFile(file)"/>
      <div class="input-data">
        <b-input @change="handleUpdate" placeholder="Название файла" v-model="file.name" />
        <span class="link" @click="handleloadFile" v-if="!file.file">
          Загрузить документ
        </span>
        <span v-else>
          <span class="link">{{file.file | path }}</span>
          <span class="delete-file" @click="deleteFile()">X</span>
        </span>
        <input type="file" id='photo' @change='loadFile' hidden ref="loadFile"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'BankRequirementFile',
  data () {
    return {
      updateTimer: null
    }
  },
  props: {
    file: {
      required: true
    }
  },
  methods: {
    ...mapActions(['deleteRequiredInformationFile', 'updateRequiredInformationFile',
      'addRequiredInformationDocument', 'loadRequiredInformationFile',
      'deleteRequiredInformationDocument']),
    handleUpdate () {
      this.updateRequiredInformationFile(this.file)
    },
    loadFile (e) {
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('document', file)
      this.file.newFile = formData
      this.file.file = file.name
      this.updateRequiredInformationFile(this.file)
      this.$forceUpdate()
    },
    deleteFile () {
      delete this.file.newFile
      this.file.file = ''
      this.updateRequiredInformationFile(this.file)
      this.$forceUpdate()
    },
    handleloadFile () {
      this.$refs.loadFile.click()
    }
  },
  filters: {
    path (path) {
      return path.split('/').pop()
    }
  }
}
</script>

<style scoped>
.document-wrapper {
  margin: 5px 0;
  padding: 15px;
}
.delete-icon {
  margin: 0 20px 0 0;
  height: 24px;
  width: 24px;
  position: initial;
}
.delete-file {
  cursor: pointer;
}
.input-data {
  width: 100%;
}
.link {
  margin: 5px 0 0;
  max-width: 150px;
}
</style>



// WEBPACK FOOTER //
// BankRequirementFile.vue?1123ca7a